import { action, createRequestTypes } from '../base';

export const productBundleActionTypes = {
  GET_PRODUCT_BUNDLE: createRequestTypes('GET_PRODUCT_BUNDLE'),
  CREATE_PRODUCT_BUNDLE: createRequestTypes('CREATE_PRODUCT_BUNDLE'),
  UPDATE_PRODUCT_BUNDLE: createRequestTypes('UPDATE_PRODUCT_BUNDLE'),
  GET_PRODUCT_BUNDLE_BY_ID: createRequestTypes('GET_PRODUCT_BUNDLE_BY_ID'),
};

/**
 * @param payload
 * @param getPoPendingApprovalLoading
 * @param tenantId
 * @param sendPOMailToVendorLoading
 * @param callback
 */
class ProductBundleActions {
  /**
   * @param {*} orgId
   * @param {*} type
   * @param {*} tenantId
   * @param {*} page
   * @param {*} limit
   * @param searchKeyword
   * @return
   */
    getProductBundle = (productSkuId, searchKeyword, tenantDepartmentId, viewType) => action(productBundleActionTypes.GET_PRODUCT_BUNDLE.REQUEST, {
      productSkuId, searchKeyword, tenantDepartmentId, viewType,
    })

    /**
     *
     * @param getProductBundleLoading
     * @return {{type: *}}
     */
    getProductBundleLoading = (getProductBundleLoading) => action(productBundleActionTypes.GET_PRODUCT_BUNDLE.LOADING, {
      getProductBundleLoading,
    })

    /**
     * @param purchaseOrders
     * @param orgPos
     * @return {{type: *}}
     */
    getProductBundleSuccess = (bundledProducts) => action(productBundleActionTypes.GET_PRODUCT_BUNDLE.SUCCESS, {
      bundledProducts,
    })

    /**
     * @param payload
     * @param callback
     * @param withApproval
     * @return {{type: *}}
     */
    createProductBundle = (payload, callback) => action(productBundleActionTypes.CREATE_PRODUCT_BUNDLE.REQUEST, {
      payload,
      callback,
    })

    /**
     * @param createProductBundleLoading
     * @param addCustomProductBundleLoading
     * @return {{type: *}}
     */
     createProductBundleLoading = (createProductBundleLoading) => action(productBundleActionTypes.CREATE_PRODUCT_BUNDLE.LOADING, {
       createProductBundleLoading,
     })

    /**
     * @param {*} payload
     * @param {*} callback
     * @param withApproval
     * @param updateProductBundle
     * @return
     */
    updateProductBundle = (payload, callback) => action(productBundleActionTypes.UPDATE_PRODUCT_BUNDLE.REQUEST, {
      payload,
      callback,

    })

    /**
     *
     * @param updateProductBundleLoading
     * @return {{type: *}}
     */
    updateProductBundleLoading = (updateProductBundleLoading) => action(productBundleActionTypes.UPDATE_PRODUCT_BUNDLE.LOADING, {
      updateProductBundleLoading,
    })

    /**
   *
   * @param payload
   * @param callback
   * @return {{type: *}}
   */
  updateProductBundleStatus = (payload, callback) => action(productBundleActionTypes.UPDATE_BULK_PO_STATUS.REQUEST, {
    payload, callback,
  })

  /**
   *
   * @param updateProductBundleStatusLoading
   * @return {{type: *}}
   */
  updateProductBundleStatusLoading = (updateProductBundleStatusLoading) => action(productBundleActionTypes.UPDATE_BULK_PO_STATUS.LOADING, {
    updateProductBundleStatusLoading,
  })

    /**
     * @param poId
     * @param tenantId
     * @param callback
     * @return {{type: *}}
     */
    getProductBundleById = (productSkuId, searchKeyword, tenantDepartmentId, viewType) => action(productBundleActionTypes.GET_PRODUCT_BUNDLE_BY_ID.REQUEST, {
      productSkuId, searchKeyword, tenantDepartmentId, viewType,
    })

    /**
     * @param getProductBundleByIdLoading
     * @return {{type: *}}
     */
     getProductBundleByIdLoading = (getProductBundleByIdLoading) => action(productBundleActionTypes.GET_PRODUCT_BUNDLE_BY_ID.LOADING, {
       getProductBundleByIdLoading,
     })

     /**
      * @param selectedProductBundle
      * @param selectedPo
      * @return {{type: *}}
      */
     getProductBundleByIdSuccess = (selectedProductBundle) => action(productBundleActionTypes.GET_PRODUCT_BUNDLE_BY_ID.SUCCESS, {
       selectedProductBundle,
     })
}

export default new ProductBundleActions();
